import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {SnackBarService} from '../../services/snackbar.service';
import {BlockedDomain} from '../../domain/bd/blocked-domain.model';
import {DPBlockedDomain} from '../../domain/bd/dp-blocked-domain.model';
@Component({
  selector: 'cm-blocklist-ad-traces-dialog',
  template: `
    <h4 mat-dialog-title>AD TRACE(s)</h4>
    <div mat-dialog-content>
      <div class="d-flex flex-column">
        <span *ngFor="let link of domain.traces" class="d-inline-block" style="word-break: break-all">
          {{link}}
        </span>
      </div>
    </div>
    <div mat-dialog-actions class="mt-3 justify-content-center">
      <button mat-raised-button color="" [mat-dialog-close]="false">Close</button>
    </div>
  `,
})
export class BlocklistAdTracesDialogComponent {

  domain: DPBlockedDomain;

  constructor(public dialogRef: MatDialogRef<BlocklistAdTracesDialogComponent>,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.domain = data.dpBlockedDomain;
  }

}
